import { lazy } from 'react';

const Fulfillment = lazy(() => import('./Fulfillment'));

export default Fulfillment;
